import { FC } from 'react';

import clsx from 'clsx';
import { Avatar, useChannelStateContext } from 'stream-chat-react';

export type Props = {};

import styles from './ChannelHeader.module.css';

export const ChannelHeader: FC<Props> = () => {
  const { channel } = useChannelStateContext();
  const { data, state } = channel;

  // @TODO: update message with a setInterval
  const { active, lastUpdated } = ((date) => {
    const diff = Math.floor(Math.abs(new Date() - date) / 1000 / 60);
    const activeNow = diff === 0;
    const stale = diff > 60;
    return {
      active: diff === 0,
      // eslint-disable-next-line no-nested-ternary
      lastUpdated: activeNow
        ? 'Active now'
        : stale
          ? undefined
          : `Active ${diff} min${diff !== 1 ? 's' : ''} ago`,
    };
  })(state.last_message_at);
  return (
    <div className={styles.gsChannelHeader}>
      <div className={styles.gsChannelAvatar}>
        <div
          className={clsx(
            styles.gsAvatarStatus,
            active && styles.gsAvatarStatusActive,
          )}
        ></div>
        <Avatar name={data.name} size={30} image={data.image} />
      </div>
      <p className={styles.gsChannelHeaderDetails}>
        {data.name}
        <small>{lastUpdated}</small>
      </p>
    </div>
  );
};
